import { useState } from 'react';

import { PdpProductSizeType, PopupViewType, usePopupView } from '@domains/pdp-common';

import { useLegacySizeRecommendationService } from './useLegacySizeRecommendationService';

export const useLegacyOthersSizeService = () => {
  const [infoOpen, setInfoOpen] = useState<boolean>(false);
  const { showPopup } = usePopupView();
  const { sizeRecommendation } = useLegacySizeRecommendationService();
  const { recommendOptionValueList, recommendationType, userAccount } = sizeRecommendation;

  const handleInfoClick = () => {
    showPopup(PopupViewType.SIZE_INFO, () => {
      setInfoOpen(true);
    });
  };

  const closeTooltip = () => {
    setInfoOpen(false);
  };

  return {
    userAccount,
    handleInfoClick,
    recommendOptionValueList: recommendOptionValueList.slice(0, 2),
    infoOpen,
    closeTooltip,
    isOptionType: recommendationType === PdpProductSizeType.OPTION,
  };
};
